var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 10.9987C1.83301 6.67749 1.83301 4.51688 3.17544 3.17446C4.51786 1.83203 6.67846 1.83203 10.9997 1.83203C15.3208 1.83203 17.4815 1.83203 18.8239 3.17446C20.1663 4.51688 20.1663 6.67749 20.1663 10.9987C20.1663 15.3199 20.1663 17.4805 18.8239 18.8229C17.4815 20.1654 15.3208 20.1654 10.9997 20.1654C6.67846 20.1654 4.51786 20.1654 3.17544 18.8229C1.83301 17.4805 1.83301 15.3199 1.83301 10.9987Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.6f1282eff8f4f9e7b8505ea6c5c95139.svg";
export { ForwardRef as ReactComponent };